import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_cell = _resolveComponent("van-cell");
  const _component_van_cell_group = _resolveComponent("van-cell-group");
  const _component_PageNavBackLayoutCpt = _resolveComponent("PageNavBackLayoutCpt");
  return _openBlock(), _createBlock(_component_PageNavBackLayoutCpt, null, {
    default: _withCtx(() => [_createVNode(_component_van_cell_group, null, {
      default: _withCtx(() => [_createVNode(_component_van_cell, {
        title: "预约",
        icon: "add-o",
        "is-link": "",
        "arrow-direction": "",
        to: "/work-wx/appoint/application"
      }), _createVNode(_component_van_cell, {
        title: "查询",
        icon: "search",
        "is-link": "",
        "arrow-direction": "",
        to: "/work-wx/appoint/query"
      }), _createVNode(_component_van_cell, {
        title: "排队",
        icon: "bar-chart-o",
        "is-link": "",
        "arrow-direction": "",
        to: "/work-wx/appoint/queue"
      })]),
      _: 1
    })]),
    _: 1
  });
}